export default [
    {
        path: "/record/statistics",
        name: "record-statistics",
        component: () => import("../../views/record/statistics.vue"),
        meta: {
            title: "区域检录统计",
            authorization: true,
            configType: 1,
        },
    },
    {
        path: "/record/monitor",
        name: "record-monitor",
        component: () => import("../../views/record/monitor.vue"),
        meta: {
            title: "最小层级监控",
            authorization: true,
            configType: 1,
        },
    },
    {
        path: "/record/status",
        name: "record-status",
        component: () => import("../../views/record/status.vue"),
        meta: {
            title: "检录状态明细",
            authorization: true,
            configType: 1,
        },
    },
    {
        path: "/record/progress",
        name: "record-progress",
        component: () => import("../../views/record/progress.vue"),
        meta: {
            title: "检录小组进度",
            authorization: true,
            configType: 2,
        },
    },
];
